import React, { useContext } from 'react'
import { usePrismicDocumentsByType } from '@prismicio/react'

import LoadingScreen from '../utils/LoadingScreen'
import { HomeBody } from '../js/components/Home/HomeBody'
import FilterContext from '../context/filterContext';

export const Home = () => {
	const [documents, { state }] = usePrismicDocumentsByType('home')
	const { loading } = useContext(FilterContext)
	return <div style={{ minHeight: "200px" }}>{(state !== 'loaded' || loading) ? <LoadingScreen /> : <HomeBody data={documents} />}</div>;
};
